module.exports = __webpack_public_path__ + "img/symbol.8366a5b9.png";